import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const MultipleChoice = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4ea__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4ea__a)">
            <path
              fillRule="evenodd"
              d="M4 9q0-2.071 1.465-3.536Q6.929 4 9 4h30q2.071 0 3.536 1.464Q44 6.93 44 9v30q0 2.071-1.464 3.535Q41.07 44 39 44H9q-2.07 0-3.535-1.465Q4 41.072 4 39V9Zm4 0v30q0 .414.293.707T9 40h30q.414 0 .707-.293T40 39V9q0-.414-.293-.707T39 8H9q-.414 0-.707.293T8 9Zm27 9c0 .53-.21 1.04-.586 1.415l-12 12a2 2 0 0 1-2.828 0l-6-6a2 2 0 0 1 2.828-2.83L21 27.173l10.586-10.586a2 2 0 0 1 2.81-.018h.001l.016.017h.001A2 2 0 0 1 35 18Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
